$(function(){
    var $presented = $('[js-presented]');
    if ( !$presented.length || !$.fn.owlCarousel ) return;

    var $presented_list = $presented.find('[js-presented-list]');
    var $header = $('[js-header]');
    var $header_button = $header.find('[js-header-action-button]');

    $presented_list.owlCarousel({
        dragEndSpeed: 600,
        navSpeed: 600,
        dotsSpeed: 600,
        autoplaySpeed: 600,
        loop: true,
        items: 1,
        stagePadding: 0,
        margin: 0,
        autoHeight: false,
        mouseDrag: true,
        dots: true,
        nav: true,
        navText: ['', ''],
        autoplay: true,
        autoplayTimeout: 7000,
        onChanged: function(e){
            if ( e.property.name == 'position' ) {
                // $owl_items.eq(e.property.value)
            }
        },
        onTranslated: function(e){},
        onInitialized: function(e){
            // $owl_items = $presented_list.find('.owl-item');

            if ( !$$.isMobile ) {
                $presented_list.find('.owl-stage').css({
                    transition: '.6s'
                });

                var $prev = $presented_list.find('.owl-prev');
                var $next = $presented_list.find('.owl-next');
                $prev.off('.hover-shift').on({
                    'mouseenter.hover-shift': function (e) {
                        $presented_list.addClass('hover-prev');
                    },
                    'mouseleave.hover-shift': function (e) {
                        $presented_list.removeClass('hover-prev');
                    }
                });
                $next.off('.hover-shift').on({
                    'mouseenter.hover-shift': function (e) {
                        $presented_list.addClass('hover-next');
                    },
                    'mouseleave.hover-shift': function (e) {
                        $presented_list.removeClass('hover-next');
                    }
                })
            }
        }
    });

    var changeHeaderColor = function () {
        var style = $presented_list.find('.owl-item.active .presented__item').data('outside-style');
        if(style === 'light'){
            $header.addClass('header_white');
            $header_button.addClass('button_gray');
        }else{
            $header.removeClass('header_white');
            $header_button.removeClass('button_gray');
        }
    };

    changeHeaderColor();
    $presented_list.on('changed.owl.carousel initialized.owl.carousel', changeHeaderColor);

});


